import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Constants from '../../utils/constants';
import { authHeader } from '../../utils/headers';

// Dérive la base API à partir d'une URL constante (même pattern que les autres *Api du projet)
function getApiBase() {
    try {
        const u = new URL(Constants.API_ROUTE_CAMPAIGNS);
        return `${u.protocol}//${u.host}`;
    } catch (e) {
        return import.meta.env.VITE_APIURL || '';
    }
}

// Extrait le path (sans host) d'une URL absolue
function toPath(url) {
    try {
        const u = new URL(url);
        return u.pathname + u.search;
    } catch (e) {
        return url;
    }
}

export const campaignsApi = createApi({
    reducerPath: 'campaignsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getApiBase(),
        prepareHeaders: (headers) => {
            const token = authHeader();
            if (typeof token === 'string' && token) {
                headers.set('authorization', token);
            }
            return headers;
        },
    }),
    tagTypes: ['Campaign'],
    endpoints: (builder) => ({
        // GET /api/campagne_lavages?client=<id> -> retourne directement hydra:member
        // Si clientId est null/undefined/'' -> pas de filtre (tous les clients)
        getCampaigns: builder.query({
            query: ({ clientId } = {}) => {
                const base = toPath(Constants.API_ROUTE_CAMPAIGNS);
                if (clientId === null || clientId === undefined || clientId === '') {
                    return base;
                }
                const sep = base.includes('?') ? '&' : '?';
                return `${base}${sep}client=${encodeURIComponent(clientId)}`;
            },
            transformResponse: (response) => {
                if (response && Array.isArray(response['hydra:member'])) {
                    return response['hydra:member'];
                }
                return Array.isArray(response) ? response : [];
            },
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Campaign', id })),
                        { type: 'Campaign', id: 'LIST' },
                    ]
                    : [{ type: 'Campaign', id: 'LIST' }],
        }),

        // GET /api/campagne_lavages/:id -> groupe `campaign:detail` (opération Get de l'entité)
        // Payload utile : id, libelle, dateDebut, chauffeur{id,libelle}, equipier{...}, patrimoine (IRI)
        getCampaign: builder.query({
            query: (id) => toPath(Constants.API_ROUTE_CAMPAIGN.replace(':id', id)),
            providesTags: (_result, _err, id) => [{ type: 'Campaign', id: String(id) }],
        }),
    }),
});

export const { useGetCampaignsQuery, useLazyGetCampaignsQuery, useGetCampaignQuery } = campaignsApi;
